import styled from 'styled-components';

export const FXRatesFormContainer = styled.div`
	display: flex;
	flex-direction: column;
	border-radius: 4px;
	border: 1px solid ${({ theme }) => theme.v2.color.neutral[300]};
	overflow: hidden;
`;

export const FXExchangeRateRow = styled.div<{ $disableBorder?: boolean }>`
	display: flex;
	flex-direction: column;
	padding: 0.5rem;
	gap: 1rem;
	border-bottom: ${({ theme, $disableBorder }) =>
		$disableBorder ? 'none' : `1px solid ${theme.v2.color.neutral[300]}`};
`;

export const ComparatorContainer = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr;
	height: 4rem;
	border-radius: 4px;
	border: 1px solid ${({ theme }) => theme.v2.color.neutral[300]};
	overflow: hidden;
`;

export const CurrencyWithFlag = styled.div`
	display: flex;
	align-items: center;
	gap: 0.5rem;
`;

const BaseRateContainer = styled.div`
	display: flex;
	justify-content: space-between;
	padding: 0.5rem;
	gap: 0.5rem;
`;

export const LiveRateContainer = styled(BaseRateContainer)`
	background-color: ${({ theme }) => theme.v2.color.neutral[100]};
	border-right: 1px solid ${({ theme }) => theme.v2.color.neutral[300]};
`;

export const StaticRateContainer = styled(BaseRateContainer)`
	background-color: ${({ theme }) => theme.v2.color.neutral[100]};
`;

export const EditingRateContainer = styled(BaseRateContainer)`
	background-color: ${({ theme }) => theme.v2.color.white[500]};
`;

const BaseRateContent = styled.div`
	display: flex;
	flex-direction: column;
`;

export const StaticRateContent = styled(BaseRateContent)`
	gap: 0.5rem;
`;

export const EditingRateContent = styled(BaseRateContent)`
	gap: 0.25rem;
`;

const BaseRateValue = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.5rem;
`;

export const StaticRateValue = styled(BaseRateValue)`
	margin-left: 1rem;
`;

export const EditingRateValue = styled(BaseRateValue)`
	margin-left: 0;

	.mantine-Input-wrapper {
		.mantine-Input-input {
			margin: 0;
		}
	}
`;

export const RateActions = styled.div`
	position: relative;
	display: flex;
	flex-direction: column;
	gap: 0.5rem;
	justify-content: flex-end;
`;

export const RateIndicator = styled.div`
	display: flex;
	gap: 0.5rem;
	align-items: center;
	justify-content: start;
`;

export const FXRatesFormHeader = styled.div`
	display: flex;
	gap: 8px;
`;
